// import React from "react";
// import {
//   TOTAL_BOSSES,
//   BOSS_STATS,
//   ASSETS,
//   ASSET_PATHS,
//   getDynamicConstants,
// } from "./animation.config";

// export const AnimationScene = ({ refs }) => {
//   const { IS_MOBILE } = getDynamicConstants();

//   return (
//     <>
//       {/* Particle Container: a dedicated layer for all generated particles for better performance and z-index control */}
//       <div ref={refs.particleContainer} className="absolute inset-0 pointer-events-none z-10 overflow-hidden" />

//       <div
//         className={`grid ${IS_MOBILE ? "grid-cols-4" : "md:grid-cols-9"} h-full w-full`}
//         ref={refs.container}
//       >
//         {/* Boss and Winner Columns */}
//         {Array.from({ length: TOTAL_BOSSES + 1 }).map((_, i) => (
//           <div
//             key={`column-${i}`}
//             className="w-full h-full md:h-[calc(100vh-6rem)] relative flex flex-col justify-end"
//           >
//             <img
//               src={ASSETS.bannerBg(i + 1)}
//               className="absolute inset-0 w-full h-full object-cover -z-10"
//               alt=""
//             />
//             <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-sm" />

//             <div
//               className="absolute bottom-0 left-0 right-0 w-full flex flex-col items-center pb-0"
//               ref={(el) => (refs.bossContainers.current[i] = el)}
//             >
//               {/* Winner Column (i === 0) */}
//               {i === 0 && (
//                 <div className="flex flex-col items-center z-10 w-full">
//                   <div
//                     ref={refs.winnerMessage}
//                     className="font-pixel text-yellow-300 text-2xl md:text-5xl p-2 md:p-3 bg-black/50 rounded-lg shadow-lg opacity-0 transform scale-80 backdrop-blur-sm border-2 border-yellow-400/50 mb-2"
//                   >
//                     VICTORY!
//                   </div>
//                   <div
//                     ref={refs.endPortal}
//                     className="relative w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-pink-500 to-pink-700/10 backdrop-blur-md border-2 border-pink-300/50 flex items-center justify-center shadow-lg -mt-4"
//                   >
//                     <img
//                       className="absolute h-20 -top-4 -bottom-1 -left-10 mb-2 portal-ring"
//                       src={ASSET_PATHS.extensionImage.ringLeft}
//                       alt="portal ring"
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Boss Columns (i > 0) */}
//               {i > 0 && i <= TOTAL_BOSSES && (
//                 <div className="flex flex-col items-center z-10 w-full">
//                   <img
//                     src={ASSETS.healthBarBase}
//                     className="w-[24px] h-auto sm:w-[32px] md:w-[48px] lg:w-[56px] mx-auto mb-1 md:mb-2 object-contain"
//                     ref={(el) => (refs.healthBars.current[i] = el)}
//                     alt="Health Bar"
//                   />
//                   <div className="relative">
//                     <img
//                       src={ASSETS.bossLogo(i)}
//                       className="w-[24px] h-auto sm:w-[32px] md:w-[48px] lg:w-[56px] mx-auto mb-1 md:mb-2 object-contain"
//                       alt={`Boss Logo ${i}`}
//                     />
//                     <img
//                       ref={(el) => (refs.statuses.current[i] = el)}
//                       src={ASSETS.completedIcon}
//                       className="hidden absolute -bottom-1 -right-1 md:bottom-0 md:right-0 w-[10px] md:w-[16px] lg:w-[20px] object-cover"
//                       alt="Completed"
//                     />
//                   </div>

//                   <div
//                     ref={(el) => (refs.bossStats.current[i] = el)}
//                     className="absolute bottom-full left-0 right-0 bg-gradient-to-b from-yellow-300/20 to-blue-300/10 backdrop-blur-sm rounded-t-lg p-2 text-white text-center opacity-0 border border-white/10 shadow-lg"
//                     style={{
//                       width: "100%",
//                       background: "rgba(255, 255, 255, 0.05)",
//                       backdropFilter: "blur(12px)",
//                       WebkitBackdropFilter: "blur(12px)",
//                       border: "1px solid rgba(255, 255, 255, 0.2)",
//                       boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.25)",
//                     }}
//                   >
//                     <div className="font-kodeMono text-xs md:text-sm">
//                       <div className="font-bold">{BOSS_STATS[i - 1].name}</div>
//                       <div>{BOSS_STATS[i - 1].speed}</div>
//                       <div>{BOSS_STATS[i - 1].cost}</div>
//                       <div className="text-yellow-300">{BOSS_STATS[i - 1].market}</div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               <img
//                 ref={(el) => (refs.banners.current[i] = el)}
//                 src={ASSETS.banner(i + 1)}
//                 className="w-full h-auto max-h-[40vh] md:max-h-[50vh] object-cover object-bottom block"
//                 alt=""
//               />
//             </div>
//           </div>
//         ))}

//         {/* Player Column */}
//         <div className="w-full h-full md:h-[calc(100vh-6rem)] relative flex flex-col justify-end">
//           <img src={ASSETS.bannerBg(9)} className="absolute inset-0 w-full h-full object-cover -z-10" alt="" />
//           <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-sm" />

//           <div className="absolute right-0 w-full h-full flex flex-col items-center justify-end">
//             <div
//               ref={refs.startPortal}
//               className="relative w-12 h-12 md:w-16 md:h-16 mt-4 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-700 backdrop-blur-md border-2 border-yellow-300/50 flex items-center justify-center shadow-lg z-10"
//             >
//               <img
//                 className="h-20 -top-10 -bottom-10 right-28 mb-2 portal-ring"
//                 src={ASSET_PATHS.extensionImage.ringLeft}
//                 alt="portal ring"
//               />
//             </div>

//             <div className="relative w-full h-2">
//               <img
//                 ref={refs.sonic}
//                 src={ASSETS.sonic}
//                 className="absolute bottom-0 z-20"
//                 style={{
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: IS_MOBILE ? "36px" : "clamp(36px, 8vw, 64px)",
//                   height: "auto",
//                   filter: "drop-shadow(0 0 8px rgba(0, 255, 255, 0.8))",
//                 }}
//                 alt="Player Character"
//               />
//             </div>

//             <img
//               src={ASSETS.banner(9)}
//               className="w-full h-auto max-h-[40vh] md:max-h-[50vh] object-cover object-bottom block"
//               alt=""
//             />
//           </div>
//         </div>
//       </div>
//       <div ref={refs.screenFlash} className="absolute inset-0 bg-white pointer-events-none opacity-0 z-50"/>
//       <style jsx>{`
//         .portal-ring {
//           will-change: transform;
//           animation: spin 5s linear infinite;
//         }
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// };

import React from "react";
import {
  TOTAL_BOSSES,
  BOSS_STATS,
  ASSETS,
  ASSET_PATHS,
  getDynamicConstants,
} from "./animation.config";

// --- Sub-components for better organization and readability ---

/**
 * A reusable wrapper for each column in the scene.
 * It handles the background image and blur overlay.
 */
const SceneColumn = ({ children, bgIndex, className = "" }) => (
  <div
    className={`w-full h-full md:h-[calc(100vh-6rem)] relative flex flex-col justify-end ${className}`}
  >
    <img
      src={ASSETS.bannerBg(bgIndex)}
      className="absolute inset-0 w-full h-full object-cover -z-10"
      alt="" // Decorative, so alt is empty
    />
    <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-black/10 backdrop-blur-sm" />
    {children}
  </div>
);

/**
 * Renders a single "Boss" column with its stats, logo, and banner.
 */
const BossColumn = ({ i, refs }) => (
  <SceneColumn bgIndex={i + 1}>
    <div
      className="absolute bottom-0 left-0 right-0 w-full flex flex-col items-center pb-0"
      ref={(el) => (refs.bossContainers.current[i] = el)}
    >
      <div className="flex flex-col items-center z-10 w-full">
        <img
          src={ASSETS.healthBarBase}
          className="w-[24px] sm:w-[32px] md:w-[48px] lg:w-[56px] mx-auto mb-1 md:mb-2 object-contain"
          ref={(el) => (refs.healthBars.current[i] = el)}
          alt="Health Bar"
        />
        <div className="relative">
          <img
            src={ASSETS.bossLogo(i)}
            className="w-[24px] sm:w-[32px] md:w-[48px] lg:w-[56px] mx-auto mb-1 md:mb-2 object-contain"
            alt={`Logo for ${BOSS_STATS[i - 1].name}`}
          />
          <img
            ref={(el) => (refs.statuses.current[i] = el)}
            src={ASSETS.completedIcon}
            className="hidden absolute -bottom-1 -right-1 md:bottom-0 md:right-0 w-[10px] md:w-[16px] lg:w-[20px] object-cover"
            alt="Completed"
          />
        </div>
        {/* FIX: Converted inline styles to Tailwind classes for maintainability */}
        <div
          ref={(el) => (refs.bossStats.current[i] = el)}
          className="absolute bottom-full w-full bg-black/30 backdrop-blur-lg rounded-t-lg p-2 text-white text-center opacity-0 border border-white/20 shadow-2xl"
        >
          <div className="font-kodeMono text-xs md:text-sm">
            <div className="font-bold">{BOSS_STATS[i - 1].name}</div>
            <div>{BOSS_STATS[i - 1].speed}</div>
            <div>{BOSS_STATS[i - 1].cost}</div>
            <div className="text-yellow-300">{BOSS_STATS[i - 1].market}</div>
          </div>
        </div>
      </div>
      <img
        ref={(el) => (refs.banners.current[i] = el)}
        src={ASSETS.banner(i + 1)}
        className="w-full h-auto max-h-[40vh] md:max-h-[50vh] object-cover object-bottom block"
        alt=""
      />
    </div>
  </SceneColumn>
);

/**
 * Renders the "Winner" column with the victory message and end portal.
 */
const WinnerColumn = ({ refs }) => (
  <SceneColumn bgIndex={1}>
    <div
      className="absolute bottom-0 left-0 right-0 w-full flex flex-col items-center pb-0"
      ref={(el) => (refs.bossContainers.current[0] = el)}
    >
      <div className="flex flex-col items-center z-10 w-full">
        <div
          ref={refs.winnerMessage}
          className="font-pixel text-yellow-300 text-2xl md:text-5xl p-2 md:p-3 bg-black/50 rounded-lg shadow-lg opacity-0 transform scale-80 backdrop-blur-sm border-2 border-yellow-400/50 mb-2"
        >
          VICTORY!
        </div>
        <div
          ref={refs.endPortal}
          className="relative w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-pink-500 to-pink-700/10 backdrop-blur-md border-2 border-pink-300/50 flex items-center justify-center shadow-lg -mt-4"
        >
          {/* FIX: Removed the .portal-ring class */}
          <img
            className="absolute h-20 -top-4 -left-10 portal-ring"
            src={ASSET_PATHS.extensionImage.ringLeft}
            alt="" // Decorative portal effect
          />
        </div>
      </div>
      <img
        ref={(el) => (refs.banners.current[0] = el)}
        src={ASSETS.banner(1)}
        className="w-full h-auto max-h-[40vh] md:max-h-[50vh] object-cover object-bottom block"
        alt=""
      />
    </div>
  </SceneColumn>
);

/**
 * Renders the "Player" column with the character and start portal.
 */
const PlayerColumn = ({ refs }) => {
  const { IS_MOBILE } = getDynamicConstants();
  return (
    <SceneColumn bgIndex={9}>
      <div className="absolute right-0 w-full h-full flex flex-col items-center justify-end">
        <div
          ref={refs.startPortal}
          className="relative w-12 h-12 md:w-16 md:h-16 mt-4 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-700 backdrop-blur-md border-2 border-yellow-300/50 flex items-center justify-center shadow-lg z-10"
        >
          {/* FIX: Removed the .portal-ring class */}
          <img
            className="h-20 -top-10 right-28 portal-ring"
            src={ASSET_PATHS.extensionImage.ringLeft}
            alt="" // Decorative portal effect
          />
        </div>
        <div className="relative w-full h-2">
          {/* FIX: Added an ID and initial inline styles to prevent FOUC */}
          <img
            id="player-character"
            ref={refs.sonic}
            src={ASSETS.sonic}
            className="absolute bottom-0 z-20"
            style={{
              left: "50%",
              transform: "translateX(-35%)",
              width: IS_MOBILE ? "36px" : "clamp(36px, 8vw, 64px)",
              height: "auto",
              filter: "drop-shadow(0 0 8px rgba(0, 255, 255, 0.8))",
              // Initially hide the element to prevent it from flashing
              // in the wrong position before GSAP takes control.
              visibility: "hidden",
              opacity: 0,
            }}
            alt="Player Character"
          />
        </div>
        <img
          src={ASSETS.banner(9)}
          className="w-full h-auto max-h-[40vh] md:max-h-[50vh] object-cover object-bottom block"
          alt=""
        />
      </div>
    </SceneColumn>
  );
};

// --- Main AnimationScene Component ---

export const AnimationScene = ({ refs }) => {
  const { IS_MOBILE } = getDynamicConstants();

  // FIX: Grid layout logic is corrected.
  // We need space for 8 bosses, 1 winner platform, and 1 player start = 10 columns total on desktop.
  const gridCols = IS_MOBILE ? "grid-cols-4" : "grid-cols-10";
  const totalColumns = TOTAL_BOSSES + 2;

  return (
    <>
      <div
        ref={refs.particleContainer}
        className="absolute inset-0 pointer-events-none z-10 overflow-hidden"
      />

      <div className={`grid ${gridCols} h-full w-full`} ref={refs.container}>
        {/* Render all columns within a single map for correct grid placement */}
        {Array.from({ length: totalColumns }).map((_, i) => {
          // The last column is the player's starting position
          if (i === totalColumns - 1) {
            return <PlayerColumn key="player-col" refs={refs} />;
          }
          // The first column is the winner's platform
          if (i === 0) {
            return <WinnerColumn key="winner-col" refs={refs} />;
          }
          // All other columns are bosses (index 1 to 8)
          // `i` corresponds to the boss index (1-8)
          return <BossColumn key={`boss-col-${i}`} i={i} refs={refs} />;
        })}
      </div>

      <div
        ref={refs.screenFlash}
        className="absolute inset-0 bg-white pointer-events-none opacity-0 z-50"
      />

      {/* FIX: Removed redundant <style jsx> block. GSAP handles the portal ring animation. */}
    </>
  );
};